import { createTheme } from "@mui/material/styles";
import { buttonColors, colorPalette, flashColors } from "./colors";

export const getTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: {
              main: colorPalette.blue300,
            },
            flashColors: flashColors.light,
            quizPopap: {
              quizBg: colorPalette.white500,
              quizText: colorPalette.gray900,
              quizInsideBg: colorPalette.white150,
              quizLineBg: colorPalette.white150,
              quizSeparator: colorPalette.gray100,
              quizSelector: colorPalette.white500,
              quizSelectorText: colorPalette.blue900,
              quizSelectorTrue: {
                bg: "#66EF6426",
                text: "#092346",
                border: "#66EF64",
              },
              quizSelectorFalse: {
                bg: "#DD503E",
              },
              quizSelectorTrueTrue: {
                bg: "#66EF64B2",
                border: "#66EF64",
              },
              quizRadio: "#C8CBDE",
              quizeGraf: "#FFFFFF",
              quizeCross: colorPalette.customLightCross,
            },
            outlinedButton: {
              bd: "transparent",
              bgHover: colorPalette.blue50,
              borderColor: colorPalette.gray200,
            },
            modalColors: {
              headerColor: colorPalette.blue900,
              bgColor: colorPalette.white150,
              bgBlockColor: colorPalette.white500,
              colorLable: colorPalette.blue900,
              separatorColor: colorPalette.gray100,
              statisticColor: colorPalette.gray300,
            },
            audioPlayer: {
              bg: colorPalette.white500,
              timeColor: colorPalette.gray300,
              waveColorStart: colorPalette.waveColorStartLight,
              waveColorEnd: colorPalette.waveColorEndLight,
            },
            background: {
              default: colorPalette.white500,
              paper: colorPalette.white500,
            },
            messageMenuDropdown: {
              bg: colorPalette.gray50,
              border: colorPalette.customBorderLight,
            },
            buttons: {
              bg: buttonColors.bg,
              textColor: buttonColors.textColor,
              timeColor: buttonColors.timeColor,
              default: buttonColors.default,
              chosen: buttonColors.chosen,
              correct: buttonColors.correct,
              chosenAndCorrect: buttonColors.chosenAndCorrect,
            },
            leaderBoardBlock: {
              textColor: colorPalette.blue900,
            },
            adminPanel: {
              mainBg: colorPalette.white200,
              previewBg: colorPalette.gray100,
              textColor: colorPalette.blue900,
              borderColor: colorPalette.gray100,
              calendarBg: colorPalette.white500,
              calendarBgHover: colorPalette.blue50,
              calendarTodayBg: "none",
            },
            liveSpeechScreen: {
              background: colorPalette.white200,
              foreground: colorPalette.blue900,
              defaultGradient: {
                default: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
                hover: "linear-gradient(180deg, #20B6C8 0%, #7C4ABF 100%)",
              },
            },
            recordingsModal: {
              background: colorPalette.white150,
              headerBg: colorPalette.blue900,
              separator: colorPalette.gray100,
              button: {
                default: colorPalette.blue300,
                hover: "rgb(71, 145, 219)",
              },
            },
            loginBg: colorPalette.dark500B2,
            input: {
              borderColor: colorPalette.gray100,
              bgColor: colorPalette.white150,
              borderColorHover: colorPalette.blue400,
              bgColorFocus: colorPalette.blue40000,
            },
            chatComponent: {
              mainBg: colorPalette.white200,
            },
            panelInfo: {
              panel: {
                bg: colorPalette.white500,
              },
              tab: {
                bg: colorPalette.white150,
                color: colorPalette.blue900,
              },
              message: {
                bg: colorPalette.blue40010,
                bgHover: colorPalette.blue100,
                timeColor: colorPalette.gray90060,
              },
              selector: {
                borderColor: colorPalette.gray100,
                color: colorPalette.blue400,
              },
              calendar: {
                bg: colorPalette.white500,
                lableColor: colorPalette.blue900,
                days: {
                  bgHover: colorPalette.blue50,
                  todayBG: "none",
                },
              },
              button: {
                bg: colorPalette.blue50,
                bgHover: colorPalette.blue100,
              },
            },
            header: {
              bgColor: colorPalette.white500,
              titalColor: colorPalette.blue900,
              userBlock: {
                nameColor: colorPalette.black900,
                linkColor: colorPalette.gray300,
              },
            },
            footer: {
              bgFooter: colorPalette.white500,
              button: {
                borderMenu: colorPalette.gray10060,
                colorMenu: colorPalette.black900,
                borderMenuFull: colorPalette.gray200,
              },
              textInput: {
                bg: colorPalette.white500,
                border: colorPalette.gray100,
                color: colorPalette.gray900,
              },
              micColorHover: colorPalette.gray100,
              micColor: colorPalette.gray900,
              menuDropdown: {
                textColor: colorPalette.gray900,
                descriptionColor: colorPalette.gray90060,
                bgColor: colorPalette.white100,
                bgColorHover: colorPalette.white500,
              },
            },
          }
        : {
            primary: {
              main: colorPalette.blue200,
            },
            flashColors: flashColors.dark,
            quizPopap: {
              quizBg: colorPalette.gray700,
              quizText: colorPalette.white500,
              quizInsideBg: colorPalette.dark200,
              quizLineBg: colorPalette.dark200,
              quizSeparator: colorPalette.gray600,
              quizSelector: colorPalette.gray700,
              quizSelectorText: colorPalette.white500,
              quizSelectorTrue: {
                bg: "#66EF6426",
                text: "#66EF64",
                border: "transparent",
              },
              quizSelectorFalse: {
                bg: "#DD503E",
              },
              quizSelectorTrueTrue: {
                bg: "#14B565",
                border: "#14B565",
              },
              quizRadio: "#7A869E",
              quizeGraf: "#272937",
              quizeCross: colorPalette.white50060,
            },
            outlinedButton: {
              bd: colorPalette.outlineButtonDark,
              bgHover: colorPalette.outlineButtonDarkHover,
              borderColor: colorPalette.gray40040,
            },
            modalColors: {
              headerColor: colorPalette.blue400,
              bgColor: colorPalette.modalBgDark,
              bgBlockColor: colorPalette.dark200,
              colorLable: colorPalette.white500,
              separatorColor: colorPalette.modalSeparatorBorder,
              statisticColor: colorPalette.gray400,
            },
            background: {
              default: colorPalette.dark100,
              paper: colorPalette.dark300,
            },
            audioPlayer: {
              bg: colorPalette.dark200,
              timeColor: colorPalette.gray400,
              waveColorStart: colorPalette.waveColorStartDark,
              waveColorEnd: colorPalette.waveColorEndDark,
            },
            messageMenuDropdown: {
              bg: colorPalette.dark200,
              border: colorPalette.gray400,
            },
            buttons: {
              bg: buttonColors.bgDark,
              textColor: buttonColors.textColorDark,
              timeColor: buttonColors.timeColorDark,
              default: buttonColors.defaultDark,
              chosen: buttonColors.chosenDark,
              correct: buttonColors.correct,
              chosenAndCorrect: buttonColors.chosenAndCorrect,
            },
            leaderBoardBlock: {
              textColor: colorPalette.white500,
            },
            adminPanel: {
              mainBg: colorPalette.gradientDark,
              previewBg: colorPalette.gradientDark,
              textColor: colorPalette.white500,
              borderColor: colorPalette.gray600,
              calendarBg: colorPalette.gray700,
              calendarBgHover: colorPalette.gray800,
              calendarTodayBg: colorPalette.blue40010,
            },
            liveSpeechScreen: {
              background: colorPalette.gradientDark,
              foreground: colorPalette.white500,
              defaultGradient: {
                default: "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
                hover: "linear-gradient(180deg, #20B6C8 0%, #7C4ABF 100%)",
              },
            },
            recordingsModal: {
              background: colorPalette.modalBgDark,
              headerBg: colorPalette.blue400,
              separator: colorPalette.modalSeparatorBorder,
              button: {
                default: colorPalette.blue200,
                hover: "rgb(121, 186, 239)",
              },
            },
            loginBg: colorPalette.dark400,
            chatComponent: {
              mainBg: colorPalette.gradientDark,
            },
            input: {
              borderColor: colorPalette.dark30099,
              bgColor: colorPalette.dark00066,
              borderColorHover: colorPalette.blue400,
              bgColorFocus: colorPalette.dark00066,
            },
            panelInfo: {
              panel: {
                bg: colorPalette.dark200,
              },
              tab: {
                bg: colorPalette.dark200,
                color: colorPalette.white500,
              },
              message: {
                bg: colorPalette.gray700,
                bgHover: colorPalette.gray800,
                timeColor: colorPalette.gray400,
              },
              selector: {
                borderColor: colorPalette.gray600,
                color: colorPalette.gray400,
              },
              calendar: {
                bg: colorPalette.gray700,
                lableColor: colorPalette.white500,
                days: {
                  bgHover: colorPalette.gray800,
                  todayBG: colorPalette.blue40010,
                },
              },
              button: {
                bg: colorPalette.blue40010,
                bgHover: colorPalette.blue40050,
              },
            },
            header: {
              bgColor: colorPalette.gray700,
              titalColor: colorPalette.white500,
              userBlock: {
                nameColor: colorPalette.white500,
                linkColor: colorPalette.gray400,
              },
            },
            footer: {
              bgFooter: colorPalette.gray700,
              button: {
                borderMenu: colorPalette.dark300,
                colorMenu: colorPalette.white300,
                borderMenuFull: colorPalette.gray500,
              },
              textInput: {
                bg: colorPalette.dark200,
                border: colorPalette.gray600,
                color: colorPalette.white500,
              },
              micColorHover: colorPalette.gray800,
              micColor: colorPalette.blue400,
              menuDropdown: {
                textColor: colorPalette.white500,
                descriptionColor: colorPalette.gray400,
                bgColor: colorPalette.dark200,
                bgColorHover: colorPalette.customDark,
              },
            },
          }),
    },
    typography: {
      fontFamily: '"Red Hat Display", sans-serif',
    },
  });
